import { render, staticRenderFns } from "./ViewDetailsModal.vue?vue&type=template&id=753de999&scoped=true&"
import script from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailsModal.vue?vue&type=style&index=0&id=753de999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753de999",
  null
  
)

export default component.exports